const focusConverterInput = () => {
  if (typeof document === 'undefined') {
    return false
  }

  const input = document.querySelector(
    'textarea[aria-label="Type to capitalize"], textarea[placeholder="Type to capitalize"]'
  )
  if (!input) {
    return false
  }

  if (document.activeElement && typeof document.activeElement.blur === 'function') {
    document.activeElement.blur()
  }

  input.focus({ preventScroll: true })
  return document.activeElement === input
}

export const onRouteUpdate = () => {
  const delays = [0, 30, 120, 300]

  delays.forEach((delay) => {
    window.setTimeout(() => {
      focusConverterInput()
    }, delay)
  })

  const observer = new MutationObserver(() => {
    if (focusConverterInput()) {
      observer.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  window.setTimeout(() => {
    observer.disconnect()
  }, 1000)
}
